<div class="modal-backdrop fixed inset-0 z-150 flex items-center justify-center p-4">
  <div class="modal-content w-full max-w-lg rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">Dokumente hochladen</h2>
      <button
        type="button"
        class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all"
        title="Schließen"
        (click)="close()"
      >
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Content -->
    <div class="p-6">
      <!-- Drop zone -->
      <div
        class="flex flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed px-6 py-10 text-center transition-colors"
        [class]="isDragOver() ? 'border-primary bg-primary/10' : 'border-border-glass bg-glass-light'"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <span class="material-icons text-5xl" [class]="isDragOver() ? 'text-primary-light' : 'text-text-muted'">upload_file</span>
        @if (isDragOver()) {
          <p class="text-sm font-medium text-primary-light">Zum Hochladen loslassen</p>
        } @else {
          <p class="text-sm text-text-secondary">Dateien hierher ziehen oder</p>
        }
        <button type="button" class="btn-primary flex items-center gap-2" (click)="fileInput.click()">
          <span class="material-icons text-lg">folder_open</span>
          Dateien auswählen
        </button>
        <input #fileInput type="file" class="hidden" multiple [accept]="accept" (change)="onFileInputChange(fileInput)" />
      </div>

      <!-- Allowed file types -->
      <div class="mt-4 flex flex-wrap items-center gap-2">
        <span class="text-xs text-text-muted">Erlaubte Formate:</span>
        @for (type of fileTypes; track type) {
          <span class="px-2.5 py-1 rounded-full text-xs font-semibold bg-glass-middle border border-border-panel text-text-secondary">
            {{ type }}
          </span>
        }
      </div>
      <p class="mt-2 text-xs text-text-muted">Max. {{ maxSizeLabel }} pro Datei · Bilder werden automatisch in PDF umgewandelt.</p>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 mt-6 pt-6 border-t border-white/10">
        <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">Abbrechen</button>
      </div>
    </div>
  </div>
</div>
